import script from "./Chat.vue?vue&type=script&setup=true&lang=js"
export * from "./Chat.vue?vue&type=script&setup=true&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=73549d61&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73549d61"]])

export default __exports__